module.exports = __webpack_public_path__ + "img/gastronomia.5ba5c63b.png";